import React, { useEffect, useState } from 'react';
import { Accordion, Col, Container, Form, Row, Table, Tab, Tabs, Button } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import StepHeader from "../../../components/v2/StepHeader"
import DepartmentHeader from "../../../components/v2/DepartmentHeader";
import DataAnalysis2Dialog from '../../../components/v2/DataAnalysis2Dialog';
import FastTextArea from '../../../components/util/FastTextArea';

import './AssessmentStep7.css';

import FORM_QUESTIONS from '../../../step7_questions.json';

function EditButton(props) {
    return (
        <>
        {props.completed
            ?
            <Button
                onClick={props.onClick}
                variant="success"
                className="w-100"
                size="md"
                id={'program-' + props.programId + '_slo-' + props.sloId}
                disabled={props.disabled}
                >
                <span className="px-2" id="edit">Edit</span>
                <FontAwesomeIcon icon={faCheck} inverse 
                    id="icon"
                    onClick={props.onClick}
                    />
            </Button>
            :
            <Button
                onClick={props.onClick}
                variant="success"
                className="w-100"
                size="md"
                id={'program-' + props.programId + '_slo-' + props.sloId}
                disabled={props.disabled}
                >
                <span className="px-2" id="edit">Edit</span>
            </Button>
        }
        </>
    )
}
function CompletedCheckBox(props) {
    return (
        <Form.Check
            type="checkbox"
            onChange={props.onChange}
            id={'program-' + props.programId + '_step-' + props.step}
            name={'program-' + props.programId + '_step-' + props.step}
            aria-label={props.ariaLabel}
            label={props.label}
            value={props.completed}
            defaultChecked={props.defaultChecked}
            disabled={props.disabled}
            />
    )
}

const EMPTY_DATA_ANALYSIS_2 = {
    "s7q1": "",
    "s7q2": "",
    "s7q3": "",
}

export default function AssessmentStep7(props) {
    const [programId, setProgramId] = useState(0)
    
    // Used for Data Analysis 2 Dialog
    const [selectedProgram, setSelectedProgram] = useState()
    const [selectedLearningOutcome, setSelectedLearningOutcome] = useState()
    const [stepData, setStepData] = useState(EMPTY_DATA_ANALYSIS_2)
    const [stepDataStore, setStepDataStore] = useState({})

    const [activeTab, setActiveTab] = useState('part-1')
    const [showModal, setShowModal] = useState(false);
    
    let prefix = 'program-';

    useEffect(() => {
        if (selectedLearningOutcome && (selectedLearningOutcome.sloId in stepDataStore)) {
            setStepData({...stepDataStore[selectedLearningOutcome.sloId]})
        } else {
            setStepData({...EMPTY_DATA_ANALYSIS_2})
        }
    }, [stepDataStore])

    useEffect(() => {
        if (selectedProgram && (selectedProgram.programId in props.step7Tab1DataStore)) {
            setStepDataStore({...props.step7Tab1DataStore[selectedProgram.programId]})
        } else {
            setStepDataStore({})
            setStepData({...EMPTY_DATA_ANALYSIS_2})
        }
    }, [selectedProgram])

    const handleOpenDialog = (event) => {
        let id = event.target.id
        let tokens = event.target.id.split('_')
        if (id === 'edit' || id === 'icon') {
            tokens = event.target.parentElement.id.split('_')
        }
        let programId = tokens[0].split('-')[1]
        let sloId = tokens[1].split('-')[1]
        let program = props.department.submittedPrograms.find(p => p.programId == programId)

        setProgramId(programId)
        setSelectedProgram(program)

        let slo = props.learningOutcomes[programId].find(lo => lo.sloId == sloId)
        setSelectedLearningOutcome({...slo})
        setStepData({...stepDataStore[sloId]})

        setShowModal(true)
    }

    const handleLearningOutcomeChanged = (event) => {
        let tmpLearningOutcome = selectedLearningOutcome ? selectedLearningOutcome : props.selectedLearningOutcome
        let previousSloId = tmpLearningOutcome.sloId
        let nextSloId = event.target.value
        let tmpSelectedProgram = selectedProgram ? selectedProgram : props.selectedProgram

        let slo = props.learningOutcomes[tmpSelectedProgram.programId].find(lo => lo.sloId == nextSloId)
        setSelectedLearningOutcome(slo)

        // Save the previous step data
        let dirtyDataStore = {...stepDataStore}
        dirtyDataStore[previousSloId] = {...stepData}
        setStepDataStore({...dirtyDataStore})

        // Show the next step data
        if (nextSloId in stepDataStore) {
            setStepData({...stepDataStore[nextSloId]})
        } else {
            setStepData({...EMPTY_DATA_ANALYSIS_2})
        }
    }

    const handleCancelDialog = () => setShowModal(false)
    const handleCloseDialog = () => {
        let sloId = selectedLearningOutcome.sloId
        let dirtyDataStore = {...stepDataStore}
        dirtyDataStore[sloId] = {...stepData}
        setStepDataStore({...dirtyDataStore})

        let data = {
            department: props.department,
            program: selectedProgram,
            learningOutcome: props.selectedLearningOutcome,
            stepDataStore: {...dirtyDataStore},
        }

        // Notify parent that we are saving step 7 data
        props.handleStep7DialogSave(data)

        setShowModal(false)
    }

    const isTab1EditAllowed = (programId, sloId) => {
        if (props.step5Tab2DataStore && (programId in props.step5Tab2DataStore)) {
            let step5Data = props.step5Tab1DataStore[programId]
            if (sloId in step5Data) {
                return false
            }
        }
        return true
    }

    const isPart2Complete = (programId) => {
        let result = true
        if (programId in props.step7Tab2DataStore) {
            let s7q1 = props.step7Tab2DataStore[programId].s7q1
            if (!s7q1 || s7q1.trim().length == 0) {
                result = false
            }
            let s7q2 = props.step7Tab2DataStore[programId].s7q2
            if (!s7q2 || s7q2.trim().length == 0) {
                result = false
            }
            let s7q3 = props.step7Tab2DataStore[programId].s7q3
            if (!s7q3 || s7q3.trim().length == 0) {
                result = false
            }
            let s7q4 = props.step7Tab2DataStore[programId].s7q4
            if (!s7q4 || s7q4.trim().length == 0) {
                result = false
            }
        }
        return result
    }

    const isPart2FormDisabled = (programId) => {
        if (!(programId in props.step7CompletionData)) {
            return true
        }

        if (props.step7CompletionData[programId] &&
            !(props.step7CompletionData[programId]?.completed)) {
            return true
        }
        
        if (programId in props.step7Tab2CompletionData) {
            return props.step7Tab2CompletionData[programId].completed 
        }
        
        return false
    }

    const isLearningOutcomeDataComplete = (programId, sloId) => {
        let result = true
        if (programId in props.step7Tab1DataStore &&
            sloId in props.step7Tab1DataStore[programId]) {
            let textS7Q1 = props.step7Tab1DataStore[programId][sloId].s7q1
            let summaryOfResultsRequired = FORM_QUESTIONS["summaryOfResults"].required
            if (summaryOfResultsRequired &&
                (!textS7Q1 || textS7Q1.trim().length == 0)) {
                result = false
            }

            let textS7Q2 = props.step7Tab1DataStore[programId][sloId].s7q2
            let interpretationOfBothRoundsRequired = FORM_QUESTIONS["interpretationOfBothRounds"].required
            if (interpretationOfBothRoundsRequired &&
                (!textS7Q2 || textS7Q2.trim().length == 0)) {
                result = false
            }

            let textS7Q3 = props.step7Tab1DataStore[programId][sloId].s7q3
            let followUpAndNextStepsRequired = FORM_QUESTIONS["followUpAndNextSteps"].required
            if (followUpAndNextStepsRequired &&
                (!textS7Q3 || textS7Q3.trim().length == 0)) {
                result = false
            }
        } else {
            result = false
        }
        return result
    }

    const isPart1Complete = (programId) => {
        // Step cannot be completed if previous steps were not.
        if (!props.step6CompletionData[programId] ||
            !props.step6CompletionData[programId].completed) {
            return false
        }
        if (!props.step5CompletionData[programId] ||
            !props.step5CompletionData[programId].completed) {
            return false
        }
        if (!props.step4CompletionData[programId] ||
            !props.step4CompletionData[programId].completed) {
            return false
        }
        if (!props.step3CompletionData[programId] ||
            !props.step3CompletionData[programId].completed) {
            return false
        }
        if (!props.step2CompletionData[programId] ||
            !props.step2CompletionData[programId].completed) {
            return false
        }
        if (!props.step1CompletionData[programId] ||
            !props.step1CompletionData[programId].completed) {
            return false
        }

        let result = true
        availableLearningOutcomes[programId].map((slo) => {
            if (programId in props.step7Tab1DataStore &&
                slo.sloId in props.step7Tab1DataStore[programId]) {
                // Summary of Second Round Results
                let textS7Q1 = props.step7Tab1DataStore[programId][slo.sloId].s7q1
                let summaryOfResultsRequired = FORM_QUESTIONS["summaryOfResults"].required
                if (summaryOfResultsRequired &&
                    (!textS7Q1 || textS7Q1.trim().length == 0)) {
                    result = false
                }

                // Interpretation of results from both rounds
                let textS7Q2 = props.step7Tab1DataStore[programId][slo.sloId].s7q2
                let interpretationOfBothRoundsRequired = FORM_QUESTIONS["interpretationOfBothRounds"].required
                if (interpretationOfBothRoundsRequired &&
                    (!textS7Q2 || textS7Q2.trim().length == 0)) {
                    result = false
                }

                // Follow-up Questions, possible next steps
                let textS7Q3 = props.step7Tab1DataStore[programId][slo.sloId].s7q3
                let followUpAndNextStepsRequired = FORM_QUESTIONS["followUpAndNextSteps"].required
                if (followUpAndNextStepsRequired &&
                    (!textS7Q3 || textS7Q3.trim().length == 0)) {
                    result = false
                }
            } else {
                if (!(programId in props.step7Tab1DataStore)) {
                    result = false
                } else if (!(slo.sloId in props.step7Tab1DataStore[programId])) {
                    result = false
                }
            }
        })

        // Disallow if Part 2 was completed
        if (programId in props.step7Tab2CompletionData
            && props.step7Tab2CompletionData[programId].completed) {
            return false
        }
        
        return result
    }

    const getFormText = (step7Tab2DataStore, programId, question) => {
        if (!(programId in step7Tab2DataStore)) {
            return ''
        }
        return step7Tab2DataStore[programId][question]
    }

    let allPrograms = props.department.submittedPrograms
    let filteredPrograms = []

    filteredPrograms = allPrograms.filter(function(obj) {
        return (props.activePrograms[obj.programId] == 'yes')
    })

    let themeName = props.theme.name
    let availableLearningOutcomes = {}
    props.department.submittedPrograms.map(program => {
        let programMappedSlos = props.mappedSlos[program.programId]
        if (!(program.programId in availableLearningOutcomes)) {
            availableLearningOutcomes[program.programId] = []
        }
        
        if (program.programId in props.learningOutcomes) {
            props.learningOutcomes[program.programId].map(slo => {
                if (slo.sloId in programMappedSlos) {
                    let mappedSlo = programMappedSlos[slo.sloId]
                    if (mappedSlo.firstTheme === themeName && mappedSlo.firstThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.secondTheme === themeName && mappedSlo.secondThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.thirdTheme === themeName && mappedSlo.thirdThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    }
                }
            })
        }
    })
    
    // defaultTabs is provided to Accordion to expand all accordion items by default.
    //let defaultTabs = Array.from(props.department.submittedPrograms, (p,k) => 'program-' + k)
    let defaultTabs = []
    props.department.submittedPrograms.forEach((p) => {
        if (!(p.programId in props.step7CompletionData && props.step7CompletionData[p.programId].completed)) {
            defaultTabs.push(prefix + p.programId)
        }
    })
    return (
        <React.Fragment>
            <StepHeader text={props.stepTitle} />
            <div className="p5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    <p>
                    Begin Step 7 by using the left tab labeled <span className="fw-bold">Part 1 – Analyze the Collected 
                    Data – Round 2</span> to analyze the second round of assessment data. Then click 
                    on the right tab labeled <span className="fw-bold">Part 2 -Final Reflection</span> to conclude the assessment 
                    process for the selected programs (degrees, certificates, and gen ed areas).  
                    </p>
                    <p>
                    Please review background information about this step before continuing: <a href="https://rise.articulate.com/share/rPhb9SpPhYGQlOeAvErCFjujKFq2VvqX" target="_blank" rel="noopener noreferrer">View</a>
                    </p>
                </div>
            </div>

            <DepartmentHeader department={props.department} />

            <div className="pb-md-4 mx-auto">
            <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                id="step7-tabs"
                fill
                >
                <Tab eventKey="part-1" title="Part 1 - Analyze the Collected Data - Round 2">
                    <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                        {
                            filteredPrograms.map((program, key) =>
                            <Accordion.Item eventKey={prefix + program.programId} key={program.programId}>
                                <Accordion.Header>
                                    {program.name} {(program.programId in props.step7CompletionData && props.step7CompletionData[program.programId].completed) ? ' - Completed' : ''}
                                </Accordion.Header>
                                <Accordion.Body>
                                <Table key={key}>
                                    <thead>
                                        <tr>
                                            <th>Learning Outcome</th>
                                            <th className="mx-auto text-center"></th>
                                            <th className="mx-auto text-center">Data Analysis</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            availableLearningOutcomes[program.programId].map((slo,index) => {
                                                return (
                                                <tr key={index}>
                                                    <td>{ slo.text }</td>
                                                    <td></td>
                                                    <td width="10%">
                                                        
                                                        <EditButton
                                                            onClick={handleOpenDialog}
                                                            programId={program.programId}
                                                            sloId={slo.sloId}
                                                            disabled={isTab1EditAllowed(program.programId, slo.sloId)}
                                                            completed={isLearningOutcomeDataComplete(program.programId, slo.sloId)}
                                                            />
                                                        
                                                    </td>
                                                </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                    </Table>
                                    <Container fluid>
                                        <Row>
                                            <Col 
                                                md={{span: 8, offset: 3}}
                                                lg={{span: 12, offset: 3}}
                                                >
                                                <CompletedCheckBox
                                                    onChange={props.onStepCompleted}
                                                    programId={program.programId}
                                                    completed={props.step7CompletionData[program.programId]?.completed}
                                                    defaultChecked={props.step7CompletionData[program.programId]?.completed}
                                                    ariaLabel="Step 7 Part 1 is complete"
                                                    label="By checking this box you are completing Step 7 - Part 1 for your program area"
                                                    step="7Tab1"
                                                    disabled={!isPart1Complete(program.programId)}
                                                    />
                                            </Col>
                                        </Row>
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>
                            )
                        }
                    </Accordion>
                    <DataAnalysis2Dialog
                        department={props.department}
                        theme={props.theme}
                        selectedProgram={selectedProgram}
                        selectedLearningOutcome={selectedLearningOutcome}
                        learningOutcomes={availableLearningOutcomes}
                        
                        sloQuestions={props.sloQuestions}
                        sloAnalysis={props.sloAnalysis[selectedProgram?.programId]}
                        showModal={showModal}
                        handleCloseDialog={handleCloseDialog}
                        handleCancelDialog={handleCancelDialog}
                        stepData={stepData}
                        step1DataStore={props.step1DataStore}
                        step2DataStore={props.step2DataStore}
                        step4DataStore={props.step4DataStore}
                        step5Tab1DataStore={props.step5Tab1DataStore}
                        step5Tab2DataStore={props.step5Tab2DataStore}
                        step1CompletionData={props.step1CompletionData}
                        step2CompletionData={props.step2CompletionData}
                        step3CompletionData={props.step3CompletionData}
                        step4CompletionData={props.step4CompletionData}
                        step5CompletionData={props.step5CompletionData}
                        step6CompletionData={props.step6CompletionData}
                        stepCompletionData={props.step7CompletionData}

                        handleLearningOutcomeChanged={handleLearningOutcomeChanged}
                        handleS7Q1Changed={(e) => setStepData(prevStepData => ({...prevStepData, s7q1: e.target.value}))}
                        handleS7Q2Changed={(e) => setStepData(prevStepData => ({...prevStepData, s7q2: e.target.value}))}
                        handleS7Q3Changed={(e) => setStepData(prevStepData => ({...prevStepData, s7q3: e.target.value}))}
                        />
                </Tab>
                <Tab eventKey="part-2" title="Part 2 - Final Reflection" tabClassName="">
                    <div className="p-5 text-center">
                        <p style={{"textIndent":"50px"}}>
                            With the input of faculty in the program/department, consider each assessed program (degree, 
                            certificate, and gen ed area) separately to respond to the reflection and conclusion prompts below.
                        </p>
                        <p>
                            <span className="ps-2 text-danger fw-bold">
                                These responses may be pulled for use in the College-wide Integration Program Review (CIPR)
                                process and read by leadership.
                            </span>
                        </p>
                    </div>
                    <div>
                        {
                            filteredPrograms.map((program, key) =>
                                <div className="pb-5" key={key}>
                                    <h4>{program.name}</h4>
                                    <Form.Group as={Row} controlId="formStep7_Q1">
                                        <Form.Label column sm="6">
                                            The assessment in this cycle focused on the learning outcomes mapped 
                                            to the universal theme "Practicing community”. What did you learn about 
                                            the teaching and learning of "Practicing Community" in your programs?
                                        </Form.Label>
                                        <Col sm="6">
                                            <FastTextArea
                                                id={'program-' + program.programId + '_q1'}
                                                callback={props.onStep7Tab2QuestionChanged}
                                                text={getFormText(props.step7Tab2DataStore, program.programId, 's7q1')}
                                                disabled={isPart2FormDisabled(program.programId)}
                                                rows="3"
                                                maxLength="2048"
                                                />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="formStep7_Q2">
                                        <Form.Label column sm="6">
                                            Did this assessment process lead to any long term changes to your
                                            programs? If so, please describe the changes and what led to them.
                                        </Form.Label>
                                        <Col sm="6">
                                            <FastTextArea
                                                id={'program-' + program.programId + '_q2'}
                                                callback={props.onStep7Tab2QuestionChanged}
                                                text={getFormText(props.step7Tab2DataStore, program.programId, 's7q2')}
                                                disabled={isPart2FormDisabled(program.programId)}
                                                rows="3"
                                                maxLength="2048"
                                                />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="formStep7_Q3">
                                        <Form.Label column sm="6">
                                            Did you see any change in student achievement as part of this
                                            assessment process? If so, please describe the changes and what
                                            led to them.
                                        </Form.Label>
                                        <Col sm="6">
                                            <FastTextArea
                                                id={'program-' + program.programId + '_q3'}
                                                callback={props.onStep7Tab2QuestionChanged}
                                                text={getFormText(props.step7Tab2DataStore, program.programId, 's7q3')}
                                                disabled={isPart2FormDisabled(program.programId)}
                                                rows="3"
                                                maxLength="2048"
                                                />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="formStep7_Q4">
                                        <Form.Label column sm="6">
                                            Describe any external factors affecting the program (degree, 
                                            certificate, or gen ed area) or affecting assessment of the program 
                                            in the current theme cycle.
                                        </Form.Label>
                                        <Col sm="6">
                                            <FastTextArea
                                                id={'program-' + program.programId + '_q4'}
                                                callback={props.onStep7Tab2QuestionChanged}
                                                text={getFormText(props.step7Tab2DataStore, program.programId, 's7q4')}
                                                disabled={isPart2FormDisabled(program.programId)}
                                                rows="3"
                                                maxLength="2048"
                                                />
                                        </Col>
                                    </Form.Group>

                                    <Container>
                                        <div className="pb-3 text-muted text-center">
                                            <p>
                                                If there are other files (tables, images, long texts, etc.) that 
                                                should be included in the assessment report for this program, they 
                                                can be stored <a href="https://livecnm.sharepoint.com/:f:/t/SAAC/EjpJ1PVzHSxNrCcNia74EFkBJpuZA5tfhDszz21aXMSDKg?e=yg1nHc" target="_blank" rel="noopener noreferrer">here</a> 
                                                <span className="text-bold"> (Note: you will have to sign in using your CNM login)</span>
                                            </p>
                                        </div>
                                    </Container>
                                    <Container fluid>
                                        <Row>
                                            <Col 
                                                md={{span: 8, offset: 3}}
                                                lg={{span: 12, offset: 3}}
                                                >
                                                <CompletedCheckBox
                                                    onChange={props.onStepCompleted}
                                                    programId={program.programId}
                                                    completed={props.step7Tab2CompletionData[program.programId]?.completed}
                                                    defaultChecked={props.step7Tab2CompletionData[program.programId]?.completed}
                                                    ariaLabel="Step 7 Part 2 is complete"
                                                    label="By checking this box you are completing Step 7 - Part 2 for your program area"
                                                    disabled={!isPart2Complete(program.programId)}
                                                    step="7Tab2"
                                                    />
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                
                            )
                        }
                    </div>
                </Tab>
            </Tabs>
            </div>
        </React.Fragment>
    )
}
